
import { Button, createTheme, Grid, Skeleton } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { config } from '../../../common/config'

import { RoutesNames } from '../../../common/routes'


const theme = createTheme()


export const cardListUseStyles = makeStyles(()=>({
    wrapper:{

    },
    itemWrapper:{
        justifyContent:'center'
    },
    item:{
        textAlign:'center',
        border:'1px solid #ced1d5',
        borderRadius:'2px',
        padding:'1rem',
        [theme.breakpoints.up('md')]:{
            height:'450px'

        }
    },
    h2:{
        fontWeight:'600',
        textAlign:'center'
    },
    evenEl:{
        [theme.breakpoints.up('sm')]:{
            borderLeft:'none'
        },
        [theme.breakpoints.down('sm')]:{
            borderTop:'none'
        }
    },
    orderBtn:{
        '&:hover':{
            cursor:'pointer'
        }
    },
    actions:{
        marginTop:'1.5rem'
    },
    skeletImg:{
        width:'65%',
        margin:'0 auto',
        [theme.breakpoints.down('md')]:{
            width:'80%'
        },
        [theme.breakpoints.down('sm')]:{
            width:'90%'
        },

    }
    

}))

const CardsList = (props) =>{
    // debugger
    const setActiveCardData = (active) =>{
       props.setActiveOrderCard(active)
    }
    const [loadingImg,setLoadingImg] = useState(false)
    const classes = cardListUseStyles()
    const {t,i18n} = useTranslation()

    const onClickAction =(index)=>{
        localStorage.setItem(config.localStorageNames.activeCard, index)
        setActiveCardData(index)
    }
    
    return(
        <div className={classes.wrapper}>
           <Grid container>
                {props.cardTypeData.map((c,index)=>{
                    return <Grid  item lg={6} md={6} sm={6} xs={12} className={classes.itemWrapper} key={c[`name_${i18n.language}`]}>
                       <div className={classes.item + " " + ((index+1)%2 ===0? classes.evenEl:'')} style={(index+1)>2?{borderTop:'none'}:{}}>
                            <h2 className={classes.h2}>{c[`name_${i18n.language}`]}</h2>
                            {/* <div>
                                {c.params.map((p,index)=>{
                                    return <div key={index}>
                                        &#9866; {p.title[i18n.language]}
                                    </div>
                                })}
                            </div> */}
                            <br/>
                            <div>
                            </div>
                                <img src={c?.image?.indexOf('http')>-1?c.image: config.baseURL+'/'+c.image} alt={c[`name_${i18n.language}`]} style={loadingImg?{maxWidth:'60%', height:'auto'}:{display:'none'}} onLoad={()=>{setLoadingImg(true)}} onLoadStart={()=>{setLoadingImg(false)}}/>
                                {!loadingImg&&<Skeleton sx={{height:'50%'}} className={classes.skeletImg} variant='rectangular' />}
                            
                            <br/>
                            <div className={classes.actions}>
                                <div>
                               <NavLink to={RoutesNames.ORDERCARD}>
                                    <Button className={classes.orderBtn} onClick={()=>{onClickAction(index)}} variant='contained' >{t('order-online-btn')}</Button>
                               </NavLink>
                                
                                </div>
                                <div style={{marginTop:'0.7rem'}}><NavLink to={RoutesNames.CARDMORE}><Button onClick={()=>{onClickAction(index)}}>{t('more-btn')}</Button></NavLink></div>
                            </div>
                            
                       </div>
                    </Grid>
                })}
           </Grid>
        </div>
    )
}


export default CardsList